import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import api from "../services/api";
import { useAuth } from "../utils/auth";
import { IMAGE_URL } from "../services/config";
const Navbar = ({ isWhiteSlide }) => {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setOffsetY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isDark = offsetY > 10 || isWhiteSlide;


  const { user } = useAuth();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setOffsetY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const handleLogout = async () => {
    try {
      await api.post("/api/logout", {}, { withCredentials: true });
      delete api.defaults.headers.common["X-CSRF-Token"];
      navigate("/");
      await logout();
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };


  return (
    <header className={`fixed left-0 top-0 w-full z-50 h-22 font-['EB_Garamond','Nunito','sans-serif'] items-center transition-colors duration-500 ${isDark ? 'bg-black/80 backdrop-blur-sm' : 'bg-white/10 backdrop-blur-sm'
      }`}>
      {/* <nav className="flex items-center justify-between text-white px-24 py-3"> */}
      <nav className="flex items-center justify-between text-white px-6 md:px-24 py-2">
        {/* Logo */}
        <div className="flex items-center justify-start">
          <img src="/AIE-150.png" alt="Logo" className="h-16" />
        </div>
        {/* Hamburger Icon - shown on small screens only */}
        <div className="md:hidden flex items-center z-50">
          <button onClick={() => setMobileMenuOpen(!isMobileMenuOpen)} className="focus:outline-none">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        {/* Navigation */}
        <ul className="hidden md:flex items-center space-x-6 pt-2 font-bold text-base relative">
          {/* HOME */}
          <li>
            <NavLink
              to="/"
              className="relative py-2 px-4 pb-[2px] after:content-[''] after:block after:h-[2px] after:w-0 hover:after:w-full after:bg-[rgb(234,126,93)] after:transition-all after:duration-300"
            >
              HOME
            </NavLink>
          </li>

          {/* SEASONS with Dropdown */}
          <li className="relative group justify-center">
            <span className="relative cursor-pointer py-2 px-4 pb-[2px] after:content-[''] after:block after:h-[2px] after:w-0 group-hover:after:w-full after:bg-[rgb(234,126,93)] after:transition-all after:duration-300">
              SEASONS
            </span>
            <div
              className="absolute top-full left-0 bg-[#002147] text-white rounded-md shadow-md z-50 opacity-0 group-hover:opacity-100 group-hover:visible invisible transition-all duration-300 delay-75 mt-1 min-w-[200px]"
            >
              <NavLink
                to="/season-one"
                className="block px-4 py-2 hover:text-[rgb(234,126,93)] transition whitespace-nowrap"
              >
                Season 1
              </NavLink>
              <NavLink
                to="/season-two"
                className="block px-4 py-2 hover:text-[rgb(234,126,93)] transition whitespace-nowrap"
              >
                Season 2
              </NavLink>
            </div>
          </li>

          {/* FACULTY */}
          <li>
            <NavLink
              to="/faculty"
              className="relative py-2 px-4 pb-[2px] after:content-[''] after:block after:h-[2px] after:w-0 hover:after:w-full after:bg-[rgb(234,126,93)] after:transition-all after:duration-300"
            >
              FACULTY
            </NavLink>
          </li>

          {/* ABOUT */}
          <li>
            <NavLink
              to="/about"
              className="relative py-2 px-4 pb-[2px] after:content-[''] after:block after:h-[2px] after:w-0 hover:after:w-full after:bg-[rgb(234,126,93)] after:transition-all after:duration-300"
            >
              ABOUT
            </NavLink>
          </li>

          {/* Profile Dropdown if logged in */}
          {user ? (
            <li className="relative group">
              <div className="flex items-center gap-2 pb-5 pt-1 cursor-pointer px-10 py-2">
                <img
                      src={
                        user.profile_image_url
                          ? `${IMAGE_URL}/${user.profile_image_url}`
                          : "/default-user.png"
                      }
                      alt="User"    
                      className="w-8 h-8 rounded-full object-cover"
                      onError={(e) => {
                        e.target.onerror = null; // prevent looping
                        e.target.src = "/default-user.png";; // fallback image
                      }}
                    />
                <span className="uppercase font-semibold">{user.first_name}</span>
              </div>
              <div className="absolute top-full right-0 bg-[#002147] text-white rounded-md shadow-md z-50 opacity-0 group-hover:opacity-100 group-hover:visible invisible transition-all duration-300 delay-75 mt-1 min-w-[200px]">
                <NavLink to="/profile" className="block px-4 py-2 hover:text-[rgb(234,126,93)] transition">My Profile</NavLink>
                <NavLink to="/profile/edit" className="block px-4 py-2 hover:text-[rgb(234,126,93)] transition">Edit Profile</NavLink>
                <NavLink to="/profile" className="block px-4 py-2 hover:text-[rgb(234,126,93)] transition">My Watchlist</NavLink>
                <NavLink to="/membership-plan" className="block px-4 py-2 hover:text-[rgb(234,126,93)] transition">Membership Plan</NavLink>
                <button onClick={handleLogout} className="block w-full text-left px-4 py-2 hover:text-[rgb(234,126,93)] transition">Log Out</button>
              </div>
            </li>
          ) : (
            <li>
              <NavLink
                to="/login"
                className="relative py-2 px-4 pb-[2px] after:content-[''] after:block after:h-[2px] after:w-0 hover:after:w-full after:bg-[rgb(234,126,93)] after:transition-all after:duration-300"
              >
                LOGIN
              </NavLink>
            </li>
          )}
        </ul>


        {/* Mobile Menu Drawer */}
        <div
          className={`fixed top-0 right-0 h-full w-72 bg-[#111] text-white z-40 transition-transform transform ${isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
            } md:hidden`}
        >
          <div className="p-6 pt-16 space-y-6 bg-[#222] font-['EB_Garamond','Nunito','sans-serif']">
            {/* Close Button */}
            <button
              onClick={() => setMobileMenuOpen(false)}
              className="text-2xl absolute top-4 right-4"
            >
              ✕
            </button>

            {/* User Section */}
            {user && (
              <div className="flex items-center gap-3 border-b border-white/30 pb-4">

                <img
                    src={
                      user.profile_image_url
                        ? `${IMAGE_URL}/${user.profile_image_url}`
                        : "/default-user.png"
                    }
                    alt="User"
                    className="w-8 h-8 rounded-full object-cover mb-4"
                    onError={(e) => {
                      e.target.onerror = null; // prevent looping
                      e.target.src = "/default-user.png";; // fallback image
                    }}
                  />
                <span className="uppercase font-semibold">{user.first_name}</span>
              </div>
            )}

            {/* Menu Items */}
            <nav className="space-y-4">
              <NavLink to="/" onClick={() => setMobileMenuOpen(false)} className="block">Home</NavLink>

              {/* Expandable Seasons Section */}
              <details className="group">
                <summary className="cursor-pointer list-none font-semibold">Seasons</summary>
                <ul className="pl-4 mt-2 space-y-2 text-sm md:flex items-center">
                  <li>
                    <NavLink to="/season-one" onClick={() => setMobileMenuOpen(false)} className="block">
                      Season 1
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/season-two" onClick={() => setMobileMenuOpen(false)} className="block">
                      Season 2
                    </NavLink>
                  </li>
                </ul>
              </details>

              <NavLink to="/faculty" onClick={() => setMobileMenuOpen(false)} className="block">Faculty</NavLink>
              <NavLink to="/about" onClick={() => setMobileMenuOpen(false)} className="block">About</NavLink>

              {/* Expandable Profile Section if Logged In */}
              {user ? (
                <details className="group pt-4 border-t border-white/30">
                  <summary className="cursor-pointer list-none font-semibold mt-4">My Account</summary>
                  <ul className="pl-4 mt-2 space-y-2 text-sm md:flex items-center">
                    <li>
                      <NavLink to="/profile" onClick={() => setMobileMenuOpen(false)} className="block">
                        My Profile
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/profile/edit" onClick={() => setMobileMenuOpen(false)} className="block">
                        Edit Profile
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/membership-plan" onClick={() => setMobileMenuOpen(false)} className="block">
                        Membership Plan
                      </NavLink>
                    </li>
                    <li>
                      <button onClick={handleLogout} className="block w-full text-left">
                        Logout
                      </button>
                    </li>
                  </ul>
                </details>
              ) : (
                <NavLink to="/login" onClick={() => setMobileMenuOpen(false)} className="block">
                  Login
                </NavLink>
              )}
            </nav>
          </div>
        </div>

      </nav>
    </header>
  );
};

export default Navbar;
